<mat-card appearance="outlined" data-tfa="noeud-form-component_card" id="noeud-form" class="mat-elevation-z3">
    @if (!!objetMaquetteSelected) {
    <mat-card-content>
        @if (tabsLayout$ | async; as tabsLayout) {
        <mat-tab-group
            mat-stretch-tabs="false"
            [selectedIndex]="selectedIndex"
            [ngClass]="tabsLayout"
            [class.someTabLabelIsOverflowing]="someTabLabelIsOverflowing"
            mat-align-tabs="start"
            (selectedIndexChange)="selectedIndex = $event"
        >
            <mat-tab disabled id="rotate-layout-tab" [labelClass]="'rotate-layout ' + tabsLayout" aria-label="Changer l'affichage">
                <ng-template mat-tab-label>
                    <mat-icon
                        id="rotate-layout-icon"
                        mat-tab-header
                        data-tfa="change-layout-icon"
                        [matTooltip]="'changer l\'affichage'"
                        (click)="toggleTabsLayout()"
                        >screen_rotation</mat-icon
                    >
                </ng-template>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    <span>Descripteurs</span>
                    @if (!descripteursObjetMaquetteComponent.form.isPristine) {
                    <mat-icon
                        matTooltip="Modifications en cours non sauvegardées"
                        color="warn"
                        data-tfa="icon-non-enregistré"
                        aria-hidden="false"
                        >warning</mat-icon
                    >
                    }
                </ng-template>
                <div class="tab-content">
                    <button
                        id="icon-bouton-fermer-objet-maquette"
                        data-tfa="objet-maquette-fermer-icon-button"
                        class="icon-bouton-fermer"
                        matTooltip="fermer"
                        mat-mini-fab
                        color="accent"
                        (click)="fermerFormulaire()"
                    >
                        <mat-icon data-tfa="icone-close">close</mat-icon>
                    </button>
                    <div class="form-container">
                        <h2>{{ objetMaquetteSelected.typeObjetMaquette }}</h2>
                    </div>
                    <p class="text-base">* Champs obligatoires</p>
                    <div class="form-field-group">
                        <form id="code-formulaire" data-tfa="form_descripteurs_objet_maquette_code" [formGroup]="codeForm">
                            <mat-form-field class="form-field code-form-field">
                                <mat-label>Code</mat-label>
                                <input
                                    data-tfa="input_code_objet_maquette"
                                    matInput
                                    formControlName="code"
                                    placeholder="Code"
                                    oninput="this.value = this.value.toUpperCase()"
                                />
                                @if (codeForm.controls.code.enabled) {
                                <div matSuffix class="code-form-suffix">
                                    <button
                                        class="code-field-button carre"
                                        data-tfa="bouton-enregistrer-code"
                                        mat-mini-fab
                                        [matTooltip]="'Enregistrer'"
                                        (click)="enregistrerCode()"
                                        [disabled]="!canSaveCode()"
                                    >
                                        <mat-icon data-tfa="unfold">save</mat-icon>
                                    </button>
                                    @if (codeForm.controls.code.dirty) {
                                    <button
                                        class="code-field-button carre"
                                        data-tfa="bouton-annuler-enregistrer-code"
                                        mat-mini-fab
                                        [matTooltip]="'Annuler'"
                                        (click)="annulerModificationCode()"
                                    >
                                        <mat-icon data-tfa="unfold">close</mat-icon>
                                    </button>
                                    }
                                </div>
                                } @if (codeForm.controls.code.errors?.required) {
                                <mat-error>Le code est obligatoire</mat-error>
                                } @if (codeForm.controls.code.errors?.minlength) {
                                <mat-error>Minimum {{ codeForm.controls.code.errors?.minlength.requiredLength }} caractères</mat-error>
                                } @if (codeForm.controls.code.errors?.maxlength) {
                                <mat-error>Maximum {{ codeForm.controls.code.errors?.maxlength.requiredLength }} caractères</mat-error>
                                } @if (codeForm.controls.code.errors?.pattern) {
                                <mat-error>Le code doit contenir uniquement des caractères alphanumériques et/ou le tiret</mat-error>
                                }
                            </mat-form-field>
                            @if (isBacASable && codeForm.controls.code.disabled) {
                            <button
                                class="code-field-button carre"
                                matSuffix
                                data-tfa="bouton-modifier-code"
                                mat-mini-fab
                                [appEnableIfAutorise]="ODF_MODIFIER_CODE_OBJET_MAQUETTE"
                                [matTooltip]="'Modifier le code'"
                                (click)="openModifierCodeConfirmationDialog()"
                            >
                                <mat-icon data-tfa="unfold">edit</mat-icon>
                            </button>
                            }
                        </form>
                        @if (objetMaquetteSelected.typeObjetMaquette !== TypesObjetsMaquette.Formation) {
                        <mat-slide-toggle
                            [checked]="objetMaquetteSelected.mutualise"
                            [appEnableIfAutorise]="objetMaquetteSelected.mutualise ? ODF_SUPPRIMER_MUTUALISE : ODF_RENDRE_MUTUALISE"
                            (toggleChange)="toggleMutualiseHandler()"
                            id="input_mutualise_objet_maquette"
                            data-tfa="input_mutualise_objet_maquette"
                            >Mutualisé</mat-slide-toggle
                        >
                        }
                    </div>
                    <app-formulaire-descripteurs-objet-maquette
                        #descripteursObjetMaquetteComponent
                        [objetMaquette]="objetMaquetteSelected"
                        [typeObjetMaquette]="objetMaquetteSelected.typeObjetMaquette!"
                        [espace]="espace"
                        [readonly]="omStructure.valide"
                    >
                        <button
                            id="bouton-fermer-objet-maquette"
                            data-tfa="objet-maquette-fermer-button"
                            mat-raised-button
                            color="accent"
                            (click)="fermerFormulaire()"
                        >
                            <mat-icon data-tfa="icone-close">close</mat-icon>
                            Annuler
                        </button>
                    </app-formulaire-descripteurs-objet-maquette>
                </div>
            </mat-tab>
            <mat-tab
                [disabled]="objetMaquetteSelected.typeObjetMaquette === TypesObjetsMaquette.Formation"
                [appEnableIfAutorise]="ODF_LISTER_CONTEXTES"
            >
                <ng-container *appShowIfAutorise="ODF_LISTER_CONTEXTES">
                    <ng-template mat-tab-label>
                        <span>Contextes</span>
                        @if ((monComp.isAllPristine$ | async) === false) {
                        <mat-icon
                            matTooltip="Modifications en cours non sauvegardées"
                            color="warn"
                            data-tfa="icon-non-enregistré"
                            aria-hidden="false"
                            >warning</mat-icon
                        >
                        }
                    </ng-template>
                    <button
                        id="icon-bouton-fermer-contextes"
                        data-tfa="contextes-fermer-icon-button"
                        class="icon-bouton-fermer"
                        matTooltip="fermer"
                        mat-mini-fab
                        color="accent"
                        (click)="fermerFormulaire()"
                    >
                        <mat-icon data-tfa="icone-close">close</mat-icon>
                    </button>
                    <app-formulaire-descripteurs-contexte
                        #monComp
                        [objetMaquetteSelected]="objetMaquetteSelected"
                        [typeObjetMaquette]="objetMaquetteSelected.typeObjetMaquette!"
                        [idContexteActuel]="contexteId()"
                        [espace]="espace"
                    >
                        <button
                            id="bouton-fermer-objet-maquette"
                            data-tfa="objet-maquette-fermer-button"
                            mat-raised-button
                            color="accent"
                            (click)="fermerFormulaire()"
                        >
                            <mat-icon data-tfa="icone-close">close</mat-icon>
                            Annuler
                        </button>
                    </app-formulaire-descripteurs-contexte>
                </ng-container>
                <ng-template #labelWhenDisabled mat-tab-label><span>Contextes</span></ng-template>
            </mat-tab>
            <mat-tab [disabled]="objetMaquetteSelected.typeObjetMaquette === TypesObjetsMaquette.Groupement">
                <ng-template mat-tab-label>
                    <span>Enquêtes</span>
                    @if (!descripteursEnqueteComponent.form.isPristine) {
                    <mat-icon
                        matTooltip="Modifications en cours non sauvegardées"
                        color="warn"
                        data-tfa="icon-non-enregistré"
                        aria-hidden="false"
                        >warning</mat-icon
                    >
                    }
                </ng-template>
                <div class="tab-content">
                    <button
                        id="icon-bouton-fermer-enquetes"
                        data-tfa="enquetes-fermer-icon-button"
                        class="icon-bouton-fermer"
                        matTooltip="fermer"
                        mat-mini-fab
                        color="accent"
                        (click)="fermerFormulaire()"
                    >
                        <mat-icon data-tfa="icone-close">close</mat-icon>
                    </button>
                    <app-formulaire-descripteurs-enquete
                        #descripteursEnqueteComponent
                        [objetMaquetteSelected]="objetMaquetteSelected"
                        [isPIAInActualContext]="!!omStructure.pia"
                        [typeObjetMaquette]="objetMaquetteSelected.typeObjetMaquette!"
                        [espace]="espace"
                    >
                        <button
                            id="bouton-fermer-objet-maquette"
                            data-tfa="objet-maquette-fermer-button"
                            mat-raised-button
                            color="accent"
                            (click)="fermerFormulaire()"
                        >
                            <mat-icon data-tfa="icone-close">close</mat-icon>
                            Annuler
                        </button></app-formulaire-descripteurs-enquete
                    >
                </div>
            </mat-tab>
            <mat-tab [disabled]="objetMaquetteSelected.typeObjetMaquette === TypesObjetsMaquette.Groupement">
                <ng-template mat-tab-label>
                    <span>Format enseignements</span>
                    @if (!descripteursFormatEnseignementsComponent.form.isPristine) {
                    <mat-icon
                        matTooltip="Modifications en cours non sauvegardées"
                        color="warn"
                        data-tfa="icon-non-enregistré"
                        aria-hidden="false"
                        >warning</mat-icon
                    >
                    }
                </ng-template>
                <div class="tab-content">
                    <button
                        id="icon-bouton-fermer-formats-enseignements"
                        data-tfa="formats-enseignements-fermer-icon-button"
                        class="icon-bouton-fermer"
                        matTooltip="fermer"
                        mat-mini-fab
                        color="accent"
                        (click)="fermerFormulaire()"
                    >
                        <mat-icon data-tfa="icone-close">close</mat-icon>
                    </button>
                    <app-formulaire-descripteurs-format-enseignements
                        #descripteursFormatEnseignementsComponent
                        [objetMaquetteSelected]="objetMaquetteSelected"
                        [espace]="espace"
                    >
                        <button
                            id="bouton-fermer-objet-maquette"
                            data-tfa="objet-maquette-fermer-button"
                            mat-raised-button
                            color="accent"
                            (click)="fermerFormulaire()"
                        >
                            <mat-icon data-tfa="icone-close">close</mat-icon>
                            Annuler
                        </button></app-formulaire-descripteurs-format-enseignements
                    >
                </div>
            </mat-tab>
            <mat-tab [disabled]="objetMaquetteSelected.typeObjetMaquette === TypesObjetsMaquette.Groupement">
                <ng-template mat-tab-label>
                    <span>Syllabus</span>
                    @if (!descripteursSyllabusComponent.form.isPristine) {
                    <mat-icon
                        matTooltip="Modifications en cours non sauvegardées"
                        color="warn"
                        data-tfa="icon-non-enregistré"
                        aria-hidden="false"
                        >warning</mat-icon
                    >
                    }
                </ng-template>
                <div class="tab-content">
                    <button
                        id="icon-bouton-fermer-syllabus"
                        data-tfa="syllabus-fermer-icon-button"
                        class="icon-bouton-fermer"
                        matTooltip="fermer"
                        mat-mini-fab
                        color="accent"
                        (click)="fermerFormulaire()"
                    >
                        <mat-icon data-tfa="icone-close">close</mat-icon>
                    </button>
                    <app-formulaire-descripteurs-syllabus
                        #descripteursSyllabusComponent
                        [objetMaquette]="objetMaquetteSelected"
                        [typeObjetMaquette]="objetMaquetteSelected.typeObjetMaquette!"
                        [espace]="espace"
                    >
                        <button
                            id="bouton-fermer-objet-maquette"
                            data-tfa="objet-maquette-fermer-button"
                            mat-raised-button
                            color="accent"
                            (click)="fermerFormulaire()"
                        >
                            <mat-icon data-tfa="icone-close">close</mat-icon>
                            Annuler
                        </button></app-formulaire-descripteurs-syllabus
                    >
                </div>
            </mat-tab>
            @if (objetMaquetteSelected.typeObjetMaquette === TypesObjetsMaquette.Formation && (mesPerimetres$ | async)?.length) {
            <mat-tab [appEnableIfAutorise]="ODF_ASSOCIER_OBJET_MAQUETTE_PERIMETRE">
                <ng-container *appShowIfAutorise="ODF_ASSOCIER_OBJET_MAQUETTE_PERIMETRE">
                    <ng-template mat-tab-label>
                        <span>Périmètres</span>
                        @if (perimetresComponent.form.dirty) {
                        <mat-icon matTooltip="Modifications en cours non sauvegardées" color="warn" data-tfa="icon-non-enregistré"
                            >warning
                        </mat-icon>
                        }
                    </ng-template>
                    <div class="tab-content">
                        <button
                            id="icon-bouton-fermer-perimetres"
                            data-tfa="perimetres-fermer-icon-button"
                            class="icon-bouton-fermer"
                            matTooltip="fermer"
                            mat-mini-fab
                            color="accent"
                            (click)="fermerFormulaire()"
                        >
                            <mat-icon data-tfa="icone-close">close</mat-icon>
                        </button>
                        <app-perimetres #perimetresComponent [objetMaquette]="objetMaquetteSelected">
                            <button
                                id="bouton-fermer-perimetres"
                                data-tfa="perimetres-fermer-button"
                                mat-raised-button
                                color="accent"
                                (click)="fermerFormulaire()"
                            >
                                <mat-icon data-tfa="icone-close">close</mat-icon>
                                Annuler
                            </button>
                        </app-perimetres>
                    </div>
                </ng-container>
            </mat-tab>
            }
            <!-- DISABLE HISTORIQUE -->
            <!-- <mat-tab label="Historique" [disabled]="isHistoriqueDisabled" [appEnableIfAutorise]="ODF_LIRE_HISTORIQUE">
                                    <div class="tab-content">
                                      <ng-template matTabContent>
                                        <button
                                          id="icon-bouton-fermer-historique"
                                          data-tfa="historique-fermer-icon-button"
                                          class="icon-bouton-fermer"
                                          matTooltip="fermer"
                                          mat-mini-fab
                                          color="accent"
                                          (click)="fermerFormulaire()"
                                          >
                                          <mat-icon data-tfa="icone-close">close</mat-icon>
                                        </button>
                                        <app-historique-objet-maquette
                                          [actualObjetMaquette]="objetMaquetteSelected"
                                          [historique]="historique!"
                                        ></app-historique-objet-maquette>
                                      </ng-template>
                                    </div>
                                  </mat-tab> -->
        </mat-tab-group>
        }
    </mat-card-content>
    }
</mat-card>

<ng-template #modifierCodeConfirmationDialogTemplate>
    <p>Attention vous êtes sur le point de modifier le code de l'objet maquette sélectionné.</p>

    <mat-divider></mat-divider>
    <div mat-dialog-actions id="modifier-code-dialog-actions">
        <button data-tfa="bouton-valider" color="accent" mat-raised-button (click)="modifierCode(); modifierCodeConfirmationDialog.close()">
            <mat-icon data-tfa="icone-valider">check</mat-icon>
            Valider
        </button>
        <button data-tfa="bouton-fermer" color="primary" mat-raised-button (click)="modifierCodeConfirmationDialog.close()">Annuler</button>
    </div>
</ng-template>
